import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { FiUpload } from "react-icons/fi";

class UploadImage extends Component {
  state = {
    selectedFile: null,
    isUploaded: false,
    imageFile: null,
    pdfFile: null
  };
  
  fileSelectedHandler = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    const fileReader = new FileReader();

    if (file.size > 5000000) {
      await this.setState({
        errorMsgSD: "File Size not permited"
      });
    } else {
      fileReader.onloadend = () => {
        this.setState({
          selectedFile: file,
          isUploaded: false,
          imageFile: fileReader.result
        });
      };
    }
    fileReader.readAsDataURL(file);
    this.props.imageData(file)
  };

  fileSelectedHandlerTemplate = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    const fileReader = new FileReader();
    if (file.type === 'application/pdf') {
      if (file.size > 5000000) {
        await this.setState({
          errorMsgSD: "File Size not permited"
        });
      } else {
        fileReader.onloadend = () => {
          this.setState({
            selectedFile: file,
            isUploaded: false,
            pdfFile: fileReader.result
          });
        };
      }
      fileReader.readAsDataURL(file);
      this.props.pdfData(file)
    
    } else if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
      if (file.size > 5000000) {
        await this.setState({
          errorMsgSD: "File Size not permited"
        });
      } else {
        fileReader.onloadend = () => {
          this.setState({
            selectedFile: file,
            isUploaded: false,
            imageFile: fileReader.result
          });
        };
      }
      fileReader.readAsDataURL(file);
      this.props.imageData(file)
    } else {      
      console.log('invalid input');
    }
  };

  deleteFile = () => {
    this.setState({
      selectedFile: null,
      isUploaded: false,
      imageFile: null,
      pdfFile: null
    });
  };

  render() {
    const { selectedFile, imageFile } = this.state;
    const data = this.props.uploadComponentData
    return (
      <>
        <Grid container style={{justifyContent: "center", flexDirection: "column"}}>
            <Grid className="text-center">
              {
                data?.page === "updateApp" && data?.logoUrl && 
                <img src={data.logoUrl} alt="photo app url" name="photoUrl" width="30%"/>
              }
              {
                data?.page === "updateApp" && !data?.logoUrl && 
                <FiUpload className="font-size-36 text-grey mb-10"/>
              }
              {
                data?.page === "profile" && data?.photoUrl &&
                <img src={data.photoUrl} alt="photo app url" name="photoUrl" width="10%" className="mb-5"/>
              }
              {
                data?.page === "profile" && !data?.photoUrl && 
                <img src="/person-dummy.png" alt="photo profile" name="profileImageUrl" width="10%" className="mb-5"/>
              }
            </Grid>
            <Grid className="text-center mt-5">
              {
                data?.page === "updateApp" && <h1 className="font-size-16">Upload Logo</h1>
              }
              {
                data?.page === "profile" && <h1 className="font-size-16">Upload Foto</h1>
              }
            </Grid>
            <Grid className="text-center">
                {
                data?.page === "newTemplate" &&
                <h1 className="font-size-12 text-grey reguler">Format file : JPG/JPEG/PNG/PDF</h1>
                }
              
                {
                data?.page !== "newTemplate" &&
                <h1 className="font-size-12 text-grey reguler">Format file : JPG/PNG</h1>
                }
            </Grid>
            <Grid container justify="center" style={{ marginTop: 5 }}>
            {
            data?.page === "newTemplate" &&
            <input
                style={{ display: "none" }}
                type="file"
                accept="image/jpg, image/jpeg, image/png, .pdf"
                onChange={this.fileSelectedHandlerTemplate}
                ref={fileInputNewTemplate => (this.fileInputNewTemplate = fileInputNewTemplate)}
            />
            }
            {
            data?.page !== "newTemplate" &&
              <input
                  style={{ display: "none" }}
                  type="file"
                  accept="image/jpeg, image/png"
                  onChange={this.fileSelectedHandler}
                  ref={fileInput => (this.fileInput = fileInput)}
              />
            }
            <Grid>
                {selectedFile !== null && (
                <>
                    <div>
                    <Typography className="font-size-14 text-grey text-center" style={{maxWidth: "125px",overflow: "hidden",whiteSpace: "nowrap"}}>
                        {selectedFile !== null && selectedFile.name}
                    </Typography>
                    </div>
                </>
                )}
                {
                data?.page !== "newTemplate" &&
                  <Button
                  onClick={() => this.fileInput.click()}
                  variant="contained"
                  color="default"
                  className="btn-black text-transform-unset"
                  >
                  Choose File
                  </Button>
                }
                {
                data?.page === "newTemplate" &&
                  <Button
                  onClick={() => this.fileInputNewTemplate.click()}
                  variant="contained"
                  color="default"
                  className="btn-black text-transform-unset"
                  >
                  Choose Files
                  </Button>
                }
            </Grid>
            </Grid>
        </Grid>
      </>
    );
  }
}

export default UploadImage;
